import React, { useEffect, useRef, useState } from "react";
import swal from "sweetalert";
import axiosInstance from "../../../services/AxiosInstance";
import { useLocation } from "react-router-dom";


import axios from "axios";
import GroupCityVenues from "./GroupCityVenues";
import ImageModal from "../../../components/ImageModal";
import ImageUploadWithCrop from "../../../components/ImageUploadWithCrop";
import SearchableUserTypeDropdown from "../permission/SearchableUserTypeDropdown";

const UPLOAD_FIELDS = {
  press_card: {
    title: "Upload Press Card Image",
    type: "image",
    acceptedTypes: ["image/jpeg", "image/jpg", "image/png", "image/webp", "image/gif", "image/bmp", "image/tiff"],
    maxSize: 2 * 1024 * 1024,
    helperText: "Upload any image format (2MB max)",
  },
  letter_of_authorization: {
    title: "Letter of Authorization",
    type: "file",
    acceptedTypes: [".pdf", ".doc", ".docx"],
    maxSize: 5 * 1024 * 1024,
    helperText: "Upload PDF/DOC/DOCX (Max size: 5 MB)",
    hasSample: true,
    sampleFile: {
      path: "Letter of Authorization Sample.pdf",
      filename: "LetterofAuthorizationSample.pdf",
    },
  },
};

const ManualForm = () => {
  const [subtypes, setSubTypes] = useState([]);
  const [sports, setSports] = useState([]);
  const [countries, setCountries] = useState([]);
  const [errors, setErrors] = useState({
    officeIDImage: "",
  });
  const [uploadedImage, setUploadedImage] = useState(null);
  const [fileError, setFileError] = useState("");
  const [uploadedOfficeId, setUploadedOfficeID] = useState(null);
  const [officeIDError, setOfficeIDError] = useState("");
  const officeIDInputRef = useRef(null);
  const fileInputRef = useRef(null);
  const uploadLetterInputRef = useRef(null);
  const [uploadLetterError, setUploadLetterError] = useState("");
  const [infinitySelected, setInfinitySelected] = useState(false);
  const [allCitiesAndVenues, setAllCitiesAndVenues] = useState({});
  const [officeIDImageURL, setOfficeIDImageURL] = useState(null);
  const [selectedVenueIds, setSelectedVenueIds] = useState([]);
  const [selectedVenueIdsState, setSelectedVenueIdsState] = useState([]);
  const [uploadLetterUploaded, setUploadLetterUploaded] = useState(false);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [userType, setUserType] = useState("");
  const [designation, setDesignation] = useState("");
  const [showHiddenFields, setShowHiddenFields] = useState(false);
  const [isDesignationDropdown, setIsDesignationDropdown] = useState(false);
  const [isMedia, setIsMedia] = useState(false);
  const [createdby, setCreatedby] = useState(0);
  const [imageURL, setImageURL] = useState(null);
  const [createdBy, setCreatedBy] = useState(null);
  const [sharedUserType, setSharedUserType] = useState(null);
  const [sharedToken, setSharedToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imageUrls, setImageUrls] = useState({
    press_card_front: "",
    press_card_back: "",
  });
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedImageAlt, setSelectedImageAlt] = useState("");

  const resetFileInputs = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    if (officeIDInputRef.current) {
      officeIDInputRef.current.value = "";
    }
    if (uploadLetterInputRef.current) {
      uploadLetterInputRef.current.value = "";
    }
  };

  useEffect(() => {
    const getAllCitiesAndVenues = async () => {
      const result = await axiosInstance.get("/venue/cities");
      setAllCitiesAndVenues(result.data.data);
    };
    getAllCitiesAndVenues();
  }, []);

  const initialForm = {
    firstname: "",
    middlename: "",
    lastname: "",
    email: "",
    mobile: "",
    categoryid: "",
    gender: "",
    photo: null,
    sportid: "",
    responsibleOrganization: "",
    designation: "",
    uploadLetter: null,
    officeIDImage: null,
    country: "",
    idType: "",
    idNumber: "",
  };

  const [form, setForm] = useState(initialForm);
  const [isShared, setIsShared] = useState(null);

  const getUserTypes = async () => {
    try {
      console.log("Fetching user types...");
      const response = await axiosInstance.get("/user-sub-type/all?page=1&limit=100", {
        timeout: 15000, // 15 second timeout
      });
      const data = response.data?.data || [];
      console.log("User types API response:", data);
      // Map the API response format to the expected format
      const mappedUserTypes = data.map((item) => ({
        id: item.sub_category_id,
        sub_category_id: item.sub_category_id,
        sub_category_name_view: item.sub_category_name_view,
        active_status: item.active_status
      }));
      console.log("Mapped user types:", mappedUserTypes);
      setSubTypes(mappedUserTypes);
    } catch (error) {
      console.error("Error fetching User Types:", error);
      
      let errorMessage = "Failed to load user types. ";
      
      if (error.code === 'ECONNABORTED') {
        errorMessage += "Request timed out. Please refresh the page.";
      } else if (error.response) {
        const status = error.response.status;
        if (status >= 500) {
          errorMessage += "Server error. Please try again later.";
        } else if (status === 404) {
          errorMessage += "User types service not available.";
        } else {
          errorMessage += "Please refresh the page to try again.";
        }
      } else if (error.request) {
        errorMessage += "Network error. Please check your connection.";
      } else {
        errorMessage += "Please refresh the page to try again.";
      }
      
      swal("Error", errorMessage, "error");
    }
  };

  const getSports = async () => {
    try {
      const response = await axiosInstance.get("/sports-name", {
        timeout: 15000, // 15 second timeout
      });
      setSports(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching sports:", error);
      
      let errorMessage = "Failed to load sports. ";
      
      if (error.code === 'ECONNABORTED') {
        errorMessage += "Request timed out. Please refresh the page.";
      } else if (error.response) {
        const status = error.response.status;
        if (status >= 500) {
          errorMessage += "Server error. Please try again later.";
        } else if (status === 404) {
          errorMessage += "Sports service not available.";
        } else {
          errorMessage += "Please refresh the page to try again.";
        }
      } else if (error.request) {
        errorMessage += "Network error. Please check your connection.";
      } else {
        errorMessage += "Please refresh the page to try again.";
      }
      
      swal("Error", errorMessage, "error");
    }
  };

  const getCountries = async () => {
    try {
      const response = await axiosInstance.get("/venue/allCountries", {
        timeout: 15000, // 15 second timeout
      });
      setCountries(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching countries:", error);
      
      let errorMessage = "Failed to load countries. ";
      
      if (error.code === 'ECONNABORTED') {
        errorMessage += "Request timed out. Please refresh the page.";
      } else if (error.response) {
        const status = error.response.status;
        if (status >= 500) {
          errorMessage += "Server error. Please try again later.";
        } else if (status === 404) {
          errorMessage += "Countries service not available.";
        } else {
          errorMessage += "Please refresh the page to try again.";
        }
      } else if (error.request) {
        errorMessage += "Network error. Please check your connection.";
      } else {
        errorMessage += "Please refresh the page to try again.";
      }
      
      swal("Error", errorMessage, "error");
    }
  };

  useEffect(() => {
    const loadData = async () => {
      await getUserTypes();
      getSports();
      getCountries();
    };
    loadData();
  }, []);


  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);

    const encryptedQR = query.get("by");
    const mediaForm = query.get("type");
    const usertypeId = query.get("usertype_id");

    console.log("URL parameters - encryptedQR:", encryptedQR, "mediaForm:", mediaForm, "usertypeId:", usertypeId);

    if (mediaForm && mediaForm === "media") {
      setIsMedia(true);
    }

    // Handle usertype_id parameter - this takes priority over token
    if (usertypeId && usertypeId !== "undefined" && usertypeId !== "null" && usertypeId !== "") {
      const idNum = parseInt(usertypeId, 10);
      if (Number.isFinite(idNum) && idNum > 0) {
        console.log("usertype_id from URL:", idNum);
        console.log("Setting sharedUserType to:", String(idNum));
        setSharedUserType(String(idNum));
        setIsShared(true);
      }
    }

    if (encryptedQR) {
      try {
        setSharedToken(encryptedQR);
        
        const decodedToken = JSON.parse(
          window.atob(encryptedQR?.split(".")[1])
        );
        console.log("decoded token", decodedToken);

        if (decodedToken) {
          setIsShared(true);
          setCreatedBy(decodedToken.shared_by);
          // Only set sharedUserType from token if usertype_id is not provided
          if (!usertypeId && decodedToken.userType) {
            const idNum = parseInt(decodedToken.userType, 10);
            if (Number.isFinite(idNum) && idNum > 0) {
              setSharedUserType(String(idNum));
            }
          }
        }
      } catch (error) {
        console.error("Invalid token:", error);
      }
    }
  }, []);

  // Process URL parameters after subtypes are loaded
  useEffect(() => {
    if (subtypes.length > 0 && sharedUserType) {
      console.log("Processing URL parameters after subtypes loaded");
      const idNum = parseInt(sharedUserType, 10);
      const isValid = Number.isFinite(idNum) && subtypes.some((t) => Number(t.sub_category_id) === idNum);
      
      if (isValid) {
        console.log("URL parameter is valid, setting form values");
        setForm((prev) => ({
          ...prev,
          categoryid: String(idNum),
        }));
        setUserType(String(idNum));
      } else {
        console.log("URL parameter is invalid, clearing sharedUserType");
        setSharedUserType(null);
      }
    }
  }, [subtypes, sharedUserType]);

  function isValidMobileNumber(number) {
    const MOBILE_NUMBER_REGEX = /^(?:\+91|0)?[6-9]\d{9}$/;
    return MOBILE_NUMBER_REGEX.test(number);
  }

  function isValidEmail(email) {
    const EMAIL_REGEX = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
    return EMAIL_REGEX.test(email);
  }

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setForm((prev) => ({
  //       ...prev,
  //       [event.target.name]: file,
  //     }));
  //   }
  // };

  const handleUploadLetterChange = async (e) => {
    const file = e.target.files[0];
    const fieldId = "letter_of_authorization";

    setUploadLetterError(""); // Clear previous error

    if (!file) {
      setUploadLetterError("Please select a file to upload.");
      return;
    }

    // Validate file type
    if (!UPLOAD_FIELDS[fieldId].acceptedTypes.includes(file.type)) {
      setUploadLetterError("Invalid file type. Please upload a PDF or Word document.");
      e.target.value = "";
      return;
    }

    if (file.size > UPLOAD_FIELDS[fieldId].maxSize) {
      setUploadLetterError("File size exceeds the limit of 5 MB.");
      e.target.value = "";
      return;
    }

    const formData = new FormData();
    formData.append("image", file);
    formData.append("id", 1);
    
    try {
      const response = await axiosInstance.post("/uploads", formData, {
        timeout: 30000, // 30 second timeout
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
      
      if (response.data && response.data.success) {
        console.log("Upload successful:", response.data.data["1"]);
      form.letter_of_authorization = response.data.data["1"];
        setUploadLetterUploaded(true);
        swal("Success", "File uploaded successfully!", "success");
      } else {
        throw new Error(response.data?.message || "Upload failed");
      }
    } catch (error) {
      console.error("File upload error:", error);
      
      let errorMessage = "An unexpected error occurred during upload.";
      
      if (error.code === 'ECONNABORTED') {
        errorMessage = "Upload timeout. Please try again with a smaller file.";
      } else if (error.response) {
        const status = error.response.status;
        const data = error.response.data;
        
        switch (status) {
          case 400:
            errorMessage = "Invalid file format. Please check your file and try again.";
            break;
          case 413:
            errorMessage = "File too large. Please reduce the file size and try again.";
            break;
          case 415:
            errorMessage = "Unsupported file type. Please upload a PDF or Word document.";
            break;
          case 500:
            errorMessage = "Server error during upload. Please try again later.";
            break;
          default:
            errorMessage = data?.message || errorMessage;
        }
      } else if (error.request) {
        errorMessage = "Network error. Please check your connection and try again.";
      }
      
      setUploadLetterError(errorMessage);
      setUploadLetterUploaded(false);
      e.target.value = ""; // Clear the file input
    }
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      // Handle file input changes
      const file = files[0];
      const maxFileSize = 2 * 1024 * 1024; // 2 MB size limit
      const allowedFileTypes = [
        "image/jpeg", 
        "image/jpg", 
        "image/png", 
        "image/webp", 
        "image/gif", 
        "image/bmp", 
        "image/tiff"
      ];

      if (file) {
        if (file.size > maxFileSize) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "File size should not exceed 2 MB.",
          }));
          e.target.value = ""; // Clear file input
          setImageURL(null); // Clear preview
        } else if (!allowedFileTypes.includes(file.type)) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "Only image files (JPEG, PNG, WEBP, GIF, BMP, TIFF) are allowed.",
          }));
          e.target.value = ""; // Clear file input
          setImageURL(null); // Clear preview
        } else {
          setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
          setForm((prev) => ({
            ...prev,
            [name]: file,
          }));

          // ✅ Add Image Preview
          const imageUrl = URL.createObjectURL(file);
          setImageURL(imageUrl);
        }
      } else {
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        setImageURL(null);
      }
    } else if (name === "categoryid") {
      // Prevent changes to user type if it's locked by a valid shared id
      const idNum = parseInt(sharedUserType, 10);
      const locked = Number.isFinite(idNum) && subtypes.some((t) => Number(t.sub_category_id) === idNum);
      if (locked) {
        return;
      }
      
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));

      if (value === "61" || value === "62") {
        setIsDesignationDropdown(false);
        setShowHiddenFields(true);
        setForm((prev) => ({
          ...prev,
          designation:
            value === "61" ? "Media-Journalist" : "Media-Photo/Video",
        }));
      } else {
        setIsDesignationDropdown(true);
        setShowHiddenFields(false);
        setForm((prev) => ({
          ...prev,
          designation: "",
        }));
      }
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    } else if (name === "designation") {
      setDesignation(value);
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else if (name === "mobile") {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
      if (value && !isValidMobileNumber(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Please enter a valid mobile number (10 digits starting with 6-9).",
        }));
      } else {
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      }
    } else if (name === "email") {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
      if (value && !isValidEmail(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Please enter a valid email address (e.g., user@example.com).",
        }));
      } else {
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      }
    } else if (name === "gender" || name === "sportid") {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    } else if (name === "firstname" || name === "middlename" || name === "lastname") {
      // Allow all characters for name fields per requirement
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    } else if (name === "country") {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    } else if (name === "idType") {
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    } else if (name === "idNumber") {
      // Allow alphanumeric characters and common symbols for ID numbers
      const idNumberRegex = /^[a-zA-Z0-9\s\-_/]*$/;
      if (value && !idNumberRegex.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "ID number can only contain letters, numbers, spaces, hyphens, underscores, and forward slashes.",
        }));
      } else {
        setForm((prev) => ({
          ...prev,
          [name]: value,
        }));
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
      }
    } else {
      // Allow all characters for remaining text fields
      setForm((prev) => ({
        ...prev,
        [name]: value,
      }));
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    }
  };

  const handleOfficeIDFileChange = (e) => {
    const file = e.target.files[0];
    const maxFileSize = 2 * 1024 * 1024; // 2MB limit
    const allowedFileTypes = [
      "image/jpeg", 
      "image/jpg", 
      "image/png", 
      "image/webp", 
      "image/gif", 
      "image/bmp", 
      "image/tiff"
    ];

    if (file) {
      if (file.size > maxFileSize) {
        setOfficeIDError("File size should not exceed 2 MB.");
        setOfficeIDImageURL(null); // Clear preview URL
        e.target.value = ""; // Reset input field
      } else if (!allowedFileTypes.includes(file.type)) {
        setOfficeIDError("Only image files (JPEG, PNG, WEBP, GIF, BMP, TIFF) are allowed.");
        setOfficeIDImageURL(null); // Clear preview URL
        e.target.value = "";
      } else {
        setOfficeIDError("");
        setForm((prev) => ({
          ...prev,
          officeIDImage: file,
        }));

        const imageUrl = URL.createObjectURL(file);
        setOfficeIDImageURL(imageUrl);
      }
    } else {
      setOfficeIDError("");
      setOfficeIDImageURL(null);
    }
  };

  const handlePhotoFileChange = (e) => {
    const file = e.target.files[0];
    const maxFileSize = 2 * 1024 * 1024; // 2MB limit
    const allowedFileTypes = [
      "image/jpeg", 
      "image/jpg", 
      "image/png", 
      "image/webp", 
      "image/gif", 
      "image/bmp", 
      "image/tiff"
    ];

    if (file) {
      if (file.size > maxFileSize) {
        setFileError("File size should not exceed 2 MB.");
        setImageURL(null); // Clear preview URL
        e.target.value = ""; // Reset input field
      } else if (!allowedFileTypes.includes(file.type)) {
        setFileError("Only image files (JPEG, PNG, WEBP, GIF, BMP, TIFF) are allowed.");
        setImageURL(null); // Clear preview URL
        e.target.value = "";
      } else {
        setFileError("");
        setForm((prev) => ({
          ...prev,
          photo: file,
        }));

        const imageUrl = URL.createObjectURL(file);
        setImageURL(imageUrl);
      }
    } else {
      setFileError("");
      setImageURL(null);
    }
  };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   const maxFileSize = 1 * 1024 * 1024;
  //   const allowedFileTypes = ["image/jpeg", "image/png", "image/jpg"];
  //   if (file) {
  //     if (file.size > maxFileSize) {
  //       setFileError("File size should not exceed 1 MB.");
  //       e.target.value = "";
  //     } else if (!allowedFileTypes.includes(file.type)) {
  //       setFileError("Only JPEG, PNG, and JPG files are allowed.");
  //       e.target.value = "";
  //     } else {
  //       setFileError("");
  //       setForm((prev) => ({
  //         ...prev,
  //         photo: file,
  //       }));
  //     }
  //   } else {
  //     setFileError("");
  //   }
  // };

  // const handleRemove = async (fieldId) => {
  //   try {
  //     const fileUrl = imageUrls[fieldId];
  //     if (!fileUrl) return;

  //     const response = await axiosInstance.delete("/uploads", {
  //       headers: {
  //         Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //       },
  //       data: {
  //         id: fieldId,
  //         filename: fileUrl,
  //       },
  //     });

  //     if (response.data.success) {
  //       setImageUrls((prev) => ({
  //         ...prev,
  //         [fieldId]: "",
  //       }));
  //       setErrors((prev) => ({
  //         ...prev,
  //         [fieldId]: null,
  //       }));
  //       swal("Success", "File deleted successfully!", "success");
  //     }
  //   } catch (error) {
  //     console.error("Delete error:", error);
  //     swal("Error", "Failed to delete file. Please try again.", "error");
  //   }
  // };
  // const handleDeleteImage = () => {
  //   setUploadedImage(null);
  // };

  const location = useLocation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields before submission
    const requiredFields = {
      firstname: form.firstname,
      email: form.email,
      mobile: form.mobile,
      gender: form.gender,
      categoryid: form.categoryid,
      responsibleOrganization: form.responsibleOrganization,
      designation: form.designation,
      country: form.country,
      idType: form.idType,
      idNumber: form.idNumber,
      photo: form.photo,
      officeIDImage: form.officeIDImage
    };

    const missingFields = Object.entries(requiredFields)
      .filter(([key, value]) => !value || (typeof value === 'string' && value.trim() === ''))
      .map(([key]) => key);

    if (missingFields.length > 0) {
      swal(
        "Validation Error",
        `Please fill in the following required fields: ${missingFields.join(', ')}`,
        "error"
      );
      return;
    }

    // Validate venue selection for media users
    if (showHiddenFields && selectedVenueIds.length === 0) {
      swal(
        "Validation Error",
        "Please select at least one venue for media personnel.",
        "error"
      );
      return;
    }

    // Validate letter upload for media users
    if (showHiddenFields && !form.letter_of_authorization) {
      swal(
        "Validation Error",
        "Please upload the letter of authorization for media personnel.",
        "error"
      );
      return;
    }

    const formData = new FormData();
    formData.append("firstname", form.firstname);
    formData.append("middlename", form.middlename || "");
    formData.append("lastname", form.lastname || "");
    formData.append("email", form.email);
    formData.append("gender", form.gender);
    formData.append("mobile_number", form.mobile);
    formData.append("sports_id", +form.sportid || "");
    formData.append("sub_category_type", form.categoryid);
    formData.append("organisation", form.responsibleOrganization);
    formData.append("designation", form.designation || "");
    formData.append("image", form.photo);
    formData.append("officeIDImage", form.officeIDImage);

    formData.append("country", form.country);
    formData.append("idType", form.idType);
    formData.append("idNumber", form.idNumber);
    formData.append("created_by", createdby);

    selectedVenueIds.forEach((id) => {
      formData.append("venue_ids", id);
    });

    formData.append("letter_of_authorization", form.letter_of_authorization);
    if (sharedToken) {
      formData.append("shared_token", sharedToken);
      console.log("Shared token added to form data:", sharedToken);
    }

    try {
      const authToken = localStorage.getItem("access_token");

      if (authToken && location.pathname === "/create-new-user") {
        const apiUrl = `/user/subAdmin`;
        setLoading(true);
        const response = await axiosInstance.post(apiUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`,
          },
          timeout: 30000, // 30 second timeout
        });

        if (response?.data?.statusCode === 200) {
          swal("Success", "User created successfully!", "success");
          setForm(initialForm);
          setSelectedVenueIds([]);
          setSelectedVenueIdsState([]);
          resetFileInputs();
          document.querySelector('input[name="officeIDImage"]').value = "";
        } else {
          const errorMessage = response?.data?.message || "Failed to create user.";
          swal("Error", errorMessage, "error");
        }
      } else {
        const apiUrl = `${process.env.REACT_APP_BASE_URL}/user/registrationform`;
        setLoading(true);
        const response = await axios.post(apiUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 30000, // 30 second timeout
        });

        if (response?.data?.statusCode === 200) {
          swal(
            "Success",
            "Registration form submitted successfully!",
            "success"
          );
          setForm(initialForm);
          setSelectedVenueIds([]);
          setSelectedVenueIdsState([]);
          resetFileInputs();
          document.querySelector('input[name="officeIDImage"]').value = "";
        } else {
          const errorMessage = response?.data?.message || "Failed to submit form.";
          swal("Error", errorMessage, "error");
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      
      let errorMessage = "An unexpected error occurred. Please try again later.";
      let errorTitle = "Error";

      if (error.code === 'ECONNABORTED') {
        errorTitle = "Timeout Error";
        errorMessage = "The request took too long to complete. Please check your internet connection and try again.";
      } else if (error.response) {
        // Server responded with error status
        const status = error.response.status;
        const data = error.response.data;
        
        switch (status) {
          case 400:
            errorTitle = "Bad Request";
            errorMessage = data?.message || "Please check your input and try again.";
            break;
          case 401:
            errorTitle = "Unauthorized";
            errorMessage = "Your session has expired. Please refresh the page and try again.";
            break;
          case 403:
            errorTitle = "Forbidden";
            errorMessage = "You don't have permission to perform this action.";
            break;
          case 404:
            errorTitle = "Not Found";
            errorMessage = "The requested service is not available.";
            break;
          case 413:
            errorTitle = "File Too Large";
            errorMessage = "The uploaded file is too large. Please reduce the file size and try again.";
            break;
          case 422:
            errorTitle = "Validation Error";
            errorMessage = data?.message || "Please check your input and try again.";
            break;
          case 429:
            errorTitle = "Too Many Requests";
            errorMessage = "Too many requests. Please wait a moment and try again.";
            break;
          case 500:
            errorTitle = "Server Error";
            errorMessage = "A server error occurred. Please try again later.";
            break;
          case 502:
          case 503:
          case 504:
            errorTitle = "Service Unavailable";
            errorMessage = "The service is temporarily unavailable. Please try again later.";
            break;
          default:
            errorMessage = data?.message || errorMessage;
        }
      } else if (error.request) {
        // Network error
        errorTitle = "Network Error";
        errorMessage = "Unable to connect to the server. Please check your internet connection and try again.";
      } else {
        // Other error
        errorMessage = error.message || errorMessage;
      }

      swal(errorTitle, errorMessage, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center" style={{ minWidth: "80vw" }}>
      <div
        className="row justify-content-center h-100 align-items-center"
        style={{ minWidth: "80vw" }}
      >
        <div className="mt-0 mb-0">
          <div className="authincation-content">
            <div className="row no-gutters">
              <div className="col-xl-12">
                <div
                  className="auth-form"
                  style={{
                    minHeight: "90vh",
                    height: "auto",
                    overflowY: "auto",
                  }}
                >
                  <div className="d-flex justify-content-center align-items-center mb-2">
                    <h3
                      style={{
                        width: "274px",
                        height: "38px",
                        position: "absolute",
                        textAlign: "center",
                        lineHeight: "38px",
                        fontSize: "24px",
                        opacity: "1",
                      }}
                    >
                      Accreditation Form
                    </h3>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <style>
                      {`
                        .form-control {
                          height: 40px !important;
                        }
                        .form-group {
                          margin-bottom: 1.5rem !important;
                        }
                        .form-group label {
                          margin-bottom: 0.5rem !important;
                        }
                      `}
                    </style>
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                      <h4 className="mb-0">
                        <label>Personal Information</label>
                      </h4>
                      <span className="text-red small">
                        * marked fields are required
                      </span>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group mb-4">
                          <label className="mb-2">
                            <strong>
                              First Name<span className="text-red">*</span>
                            </strong>
                          </label>
                          <input
                            type="text"
                            name="firstname"
                            className="form-control"
                            placeholder="First Name"
                            value={form.firstname}
                            onChange={handleChange}
                            required
                          />
                          {errors.firstname && (
                            <span className="text-danger">
                              {errors.firstname}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group mb-4">
                          <label className="mb-2">
                            <strong>Middle Name</strong>
                          </label>
                          <input
                            type="text"
                            name="middlename"
                            className="form-control"
                            placeholder="Middle Name"
                            value={form.middlename}
                            onChange={handleChange}
                          />
                          {errors.middlename && (
                            <span className="text-danger">
                              {errors.middlename}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group mb-4">
                          <label className="mb-2">
                            <strong>Last Name</strong>
                          </label>
                          <input
                            type="text"
                            name="lastname"
                            className="form-control"
                            placeholder="Last Name"
                            value={form.lastname}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group mb-4">
                          <label className="mb-2">
                          <strong>
                            Gender<span className="text-red">*</span>
                          </strong>
                          </label>
                          <select
                            name="gender"
                            className="form-control"
                            value={form.gender}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select Gender</option>
                            <option value="1">Male</option>
                            <option value="2">Female</option>
                            <option value="3">Other</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group mb-4">
                          <label className="mb-2">
                            <strong>
                              Email<span className="text-red">*</span>
                            </strong>
                          </label>
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder="Email"
                            value={form.email || ""}
                            onChange={(e) => handleChange(e)}
                            required
                          />
                          {errors.email && (
                            <div className="text-danger mt-1">
                              {errors.email}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group mb-4">
                          <label className="mb-2">
                            <strong>
                              Mobile Number<span className="text-red">*</span>
                            </strong>
                          </label>
                          <input
                            type="text"
                            name="mobile"
                            className="form-control"
                            placeholder="Mobile Number"
                            value={form.mobile || ""}
                            onChange={(e) => handleChange(e)}
                            required
                          />
                          {errors.mobile && (
                            <div className="text-danger mt-1">
                              {errors.mobile}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group mb-4">
                          <label className="mb-2">
                          <strong>
                              Select User Type<span className="text-red">*</span>
                          </strong>
                          </label>
                          <SearchableUserTypeDropdown
                            userTypes={subtypes.filter((type) =>
                              isMedia
                                ? type.sub_category_id === 61 ||
                                  type.sub_category_id === 62
                                : true
                            )}
                            value={(() => {
                              const val = sharedUserType || form.categoryid;
                              console.log("SearchableUserTypeDropdown value calculation - sharedUserType:", sharedUserType, "form.categoryid:", form.categoryid, "final value:", val);
                              return val;
                            })()}
                            onChange={(value) => {
                              console.log("SearchableUserTypeDropdown onChange called with:", value);
                              const event = {
                                target: {
                                  name: "categoryid",
                                  value: value
                                }
                              };
                              handleChange(event);
                            }}
                            placeholder="Select User Type"
                            required={true}
                            disabled={(() => {
                              const idNum = parseInt(sharedUserType, 10);
                              const isDisabled = Number.isFinite(idNum) &&
                                subtypes.some((t) => Number(t.sub_category_id) === idNum);
                              console.log("SearchableUserTypeDropdown disabled:", isDisabled, "sharedUserType:", sharedUserType);
                              return isDisabled;
                            })()}
                            className="form-control"
                            filterActiveOnly={true}
                            useStandardFormControl={true}
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group mb-4">
                          <label className="mb-2">
                            <strong>
                              Upload Profile Image<span className="text-red">*</span>
                              <i
                                className="fa fa-info-circle ms-2 text-muted"
                                title="Upload a clear profile photo. Supported formats: JPEG, PNG, WEBP, GIF, BMP, TIFF. Max size: 2MB. Square aspect ratio recommended."
                                style={{ cursor: "pointer" }}
                              ></i>
                            </strong>
                          </label>
                        <ImageUploadWithCrop
                          name="photo"
                            label=""
                          // required={true}
                          onChange={handlePhotoFileChange}
                          error={fileError}
                          onPreviewClick={(imageUrl, imageAlt) => {
                            setSelectedImage(imageUrl);
                            setSelectedImageAlt(imageAlt);
                            setShowImageModal(true);
                          }}
                          maxSize={2 * 1024 * 1024} // 2MB
                          acceptedTypes={[
                            "image/jpeg", 
                            "image/jpg", 
                            "image/png", 
                            "image/webp", 
                            "image/gif", 
                            "image/bmp", 
                            "image/tiff"
                          ]}
                          aspectRatio={1} // Square aspect ratio for profile images
                        />
                        </div>
                      </div>

                      {/* </div> */}

                      <div className="col-md-4">
                        <div className="form-group mb-4">
                          <label className="mb-2">
                            <strong>
                              Responsible Organization<span className="text-red">*</span>
                            </strong>
                          </label>
                          <input
                            type="text"
                            name="responsibleOrganization"
                            className="form-control"
                            placeholder="Responsible Organization"
                            value={form.responsibleOrganization}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group mb-4">
                          <label className="mb-2">
                            <strong>
                              Designation<span className="text-red">*</span>
                            </strong>
                          </label>

                          {userType === "61" || userType === "62" ? (
                            <input
                              type="text"
                              name="designation"
                              className="form-control"
                              value={form.designation}
                              readOnly
                              required
                            />
                          ) : (
                            <input
                              type="text"
                              name="designation"
                              className="form-control"
                              placeholder="Enter Designation"
                              value={form.designation}
                              onChange={handleChange}
                              required
                            />
                          )}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group mb-4">
                          <label className="mb-2">
                            <strong>
                              Country<span className="text-red">*</span>
                            </strong>
                          </label>
                          <select
                            name="country"
                            className="form-control"
                            value={form.country}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select Country</option>
                            {countries.map((country) => (
                              <option key={country.id} value={country.id}>
                                {country.name}
                              </option>
                            ))}
                          </select>
                          {errors.country && (
                            <div className="text-danger mt-1">
                              {errors.country}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group mb-4">
                          <label className="mb-2">
                            <strong>
                              ID Type<span className="text-red">*</span>
                            </strong>
                          </label>
                          <select
                            name="idType"
                            className="form-control"
                            value={form.idType}
                            onChange={handleChange}
                            required
                          >
                            <option value="">Select ID Type</option>
                            <option value="passport">Passport</option>
                            <option value="aadhaarcard">Aadhaar</option>
                          </select>
                          {errors.idType && (
                            <div className="text-danger mt-1">
                              {errors.idType}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group mb-4">
                          <label className="mb-2">
                            <strong>
                              ID Number<span className="text-red">*</span>
                            </strong>
                          </label>
                          <input
                            type="text"
                            name="idNumber"
                            className="form-control"
                            placeholder="Enter ID Number"
                            value={form.idNumber}
                            onChange={handleChange}
                            required
                          />
                          {errors.idNumber && (
                            <div className="text-danger mt-1">
                              {errors.idNumber}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="form-group mb-4">
                          <label className="mb-2">
                            <strong>
                              Upload ID Document<span className="text-red">*</span>
                            <i
                              className="fa fa-info-circle ms-2 text-muted"
                                title="Upload your ID document. For media personnel: Press card. For others: Office ID or Aadhar card. Supported formats: JPEG, PNG, WEBP, GIF, BMP, TIFF. Max size: 2MB. ID card aspect ratio recommended."
                              style={{ cursor: "pointer" }}
                            ></i>
                            </strong>
                          </label>
                          <ImageUploadWithCrop
                            name="officeIDImage"
                            label=""
                            // required={true}
                            onChange={handleOfficeIDFileChange}
                            error={officeIDError}
                            onPreviewClick={(imageUrl, imageAlt) => {
                              setSelectedImage(imageUrl);
                              setSelectedImageAlt(imageAlt);
                              setShowImageModal(true);
                            }}
                            maxSize={2 * 1024 * 1024} // 2MB
                            acceptedTypes={[
                              "image/jpeg", 
                              "image/jpg", 
                              "image/png", 
                              "image/webp", 
                              "image/gif", 
                              "image/bmp", 
                              "image/tiff"
                            ]}
                            aspectRatio={1.4} // Common ID card aspect ratio
                          />
                        </div>
                      </div>

                      {showHiddenFields && (
                        <>
                          {/* Media Personnel Section Divider */}
                          <div className="col-12">
                            <hr className="my-4" />
                            <div className="mb-4 d-flex justify-content-between align-items-center">
                              <h5 className="mb-0 text-primary">
                                <i className="fa fa-camera me-2"></i>
                                Media Personnel Information
                              </h5>
                            </div>
                          </div>
                          
                          {/* Select Venues Section */}
                          <div className="col-md-6">
                            <div className="form-group mb-4">
                            <label className="mb-2">
                              <strong>
                                Select Venues<span className="text-red">*</span>
                                  <i
                                    className="fa fa-info-circle ms-2 text-muted"
                                    title="Select the venues you will be covering. You can select multiple venues."
                                    style={{ cursor: "pointer" }}
                                  ></i>
                              </strong>
                            </label>
                            {allCitiesAndVenues.length && (
                              <GroupCityVenues
                                allCitiesAndVenues={allCitiesAndVenues}
                                setSelectedVenueIds={setSelectedVenueIds}
                                setInfinitySelected={setInfinitySelected}
                                selectedVenueIds={selectedVenueIds}
                                selectedVenueIdsState={selectedVenueIdsState}
                                setSelectedVenueIdsState={
                                  setSelectedVenueIdsState
                                }
                              />
                            )}
                            </div>
                          </div>

                          {/* Upload Letter Section */}
                          <div className="col-md-12 mb-4">
                            <div className="form-group mb-4">
                              <label className="mb-2">
                                <strong>
                                  Upload Letter of Authorization<span className="text-red">*</span>
                                  <i
                                    className="fa fa-info-circle ms-2 text-muted"
                                    title="Upload the letter of authorization on your organization's letterhead. Download the sample format, fill it out, and upload as PDF. Max size: 5MB."
                                    style={{ cursor: "pointer" }}
                                  ></i>
                                </strong>
                            </label>
                            <div
                              className="d-flex gap-4 align-items-start"
                              style={{
                                padding: "15px",
                                border: "1px solid #ddd",
                                borderRadius: "8px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              <div
                                style={{
                                  maxWidth: "300px",
                                  fontSize: "14px",
                                  lineHeight: "1.6",
                                }}
                              >
                                <h6
                                  style={{
                                    fontWeight: "bold",
                                    marginBottom: "10px",
                                  }}
                                >
                                  Steps to Upload:
                                </h6>
                                <ol
                                  style={{
                                    paddingLeft: "18px",
                                    marginBottom: 0,
                                  }}
                                >
                                  <li>1. Download the sample format.</li>
                                  <li>
                                    2. Fill it out on your organization's
                                    letterhead.
                                  </li>
                                  <li>
                                    3. Re-upload the document in PDF format.
                                  </li>
                                </ol>
                              </div>

                              {/* Upload Section */}
                              <div>
                                <div className="d-flex gap-2">
                                  <button
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => {
                                      const link = document.createElement("a");
                                      link.href =
                                        "Letter of Authorization Sample.pdf";
                                      link.download =
                                        "LetterofAuthorizationSample.pdf";
                                      link.click();
                                    }}
                                    type="button"
                                  >
                                    <i className="fa fa-download me-2"></i>{" "}
                                    Sample File
                                  </button>
                                  <input
                                    type="file"
                                    id="uploadLetter"
                                    name="uploadLetter"
                                    className="d-none"
                                    ref={uploadLetterInputRef}
                                    onChange={(e) => {
                                      const file = e.target.files[0];

                                      if (
                                        file &&
                                        file.type !== "application/pdf"
                                      ) {
                                        setUploadLetterError(
                                          "Only PDF files are allowed."
                                        );
                                        setUploadLetterUploaded(false);
                                        e.target.value = "";
                                        return;
                                      }

                                      if (file && file.size > 5 * 1024 * 1024) {
                                        setUploadLetterError(
                                          "File size exceeds 5 MB."
                                        );
                                        setUploadLetterUploaded(false);
                                        e.target.value = "";
                                        return;
                                      }

                                      setUploadLetterError("");
                                      handleUploadLetterChange(e);
                                      setUploadLetterUploaded(true);
                                    }}
                                    accept=".pdf"
                                    required
                                  />
                                  <button
                                    className={`btn btn-sm ${
                                      uploadLetterUploaded
                                        ? "btn-success"
                                        : "btn-primary"
                                    }`}
                                    type="button"
                                    onClick={() =>
                                      uploadLetterInputRef.current?.click()
                                    }
                                  >
                                    <i
                                      className={`fa ${
                                        uploadLetterUploaded
                                          ? "fa-check me-2"
                                          : "fa-upload me-2"
                                      }`}
                                    ></i>
                                    {uploadLetterUploaded
                                      ? "Uploaded"
                                      : "Upload"}
                                  </button>
                                </div>
                                {uploadLetterError && (
                                  <div className="text-danger small mt-1">
                                    {uploadLetterError}
                                  </div>
                                )}
                                <small
                                  className="text-muted d-block mt-2"
                                  style={{ fontSize: "12px", marginTop: "5px" }}
                                >
                                  Supported formats: PDF (Max size: 5 MB).
                                </small>
                              </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="row mt-5">
                      <div className="col-12">
                        <div className="d-flex justify-content-center align-items-center py-4">
                      {/* <button
                        className="btn btn-primary"
                        type="submit"
                        style={{
                          width: "285px",
                          height: "42px",
                          top: "930px",
                          left: "577px",
                          gap: "0px",
                          opacity: "0px",
                          background:
                            "linear-gradient(90deg, #2A1647 0%, #7942D1 100%)",
                        }}
                      >
                        Submit
                      </button> */}

                      <button
                        className="btn btn-primary d-flex align-items-center justify-content-center"
                        type="submit"
                        style={{
                          width: "285px",
                          height: "42px",
                          top: "930px",
                          left: "577px",
                          opacity: "1",
                        }}
                        disabled={loading} // Disable button while loading
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Submitting...
                          </>
                        ) : (
                          "Submit"
                        )}
                      </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      <ImageModal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        imageUrl={selectedImage}
        imageAlt={selectedImageAlt}
      />
    </div>
  );
};
export default ManualForm;
